import { render, staticRenderFns } from "./CreateCompanyPage.vue?vue&type=template&id=d90e6b98&scoped=true"
import script from "./CreateCompanyPage.vue?vue&type=script&lang=ts"
export * from "./CreateCompanyPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90e6b98",
  null
  
)

export default component.exports